import { VpButton, VpDivider } from '@vtmn-play/react'
import { useTranslation } from 'react-i18next'
import { useParams, useSearchParams } from 'react-router'
import { useProductsContext } from '@/contexts/products/useProductsContext'
import { ANALYTICS_EVENTS, trackAnalyticsEvent } from '@/services/analytics'

export function ProductsViewHeaderViewModeToggle() {
  const { t } = useTranslation()
  const [, setSearchParams] = useSearchParams()
  const { season } = useParams<{ season: string }>()
  const { setViewMode, viewMode } = useProductsContext()

  const handleViewModeChange = (nextViewMode: 'sm' | 'model') => {
    setViewMode(nextViewMode)
    setSearchParams((previous) => {
      const next = new URLSearchParams(previous)
      next.set('viewMode', nextViewMode)
      if (nextViewMode === 'sm')
        next.delete('homologation_countries')
      return next
    })
  }

  const renderButton = (nextViewMode: 'sm' | 'model') => (
    <VpButton
      variant={viewMode === nextViewMode ? 'primary' : 'secondary'}
      size="small"
      className={`products-view-header__toggle--${nextViewMode}`}
      onClick={() => {
        if (viewMode !== nextViewMode) {
          trackAnalyticsEvent(ANALYTICS_EVENTS.PRODUCTS_VIEW_MODE_SWITCHED, { season, view_mode: nextViewMode })
        }
        handleViewModeChange(nextViewMode)
      }}
    >
      {t(`products-page.view-toggle.${nextViewMode}`)}
    </VpButton>
  )

  return (
    <>
      <div className="products-view-header__toggle" data-testid="products-view-header__toggle" id="products-view-header__toggle">
        {renderButton('sm')}
        {renderButton('model')}
      </div>
      <VpDivider orientation="vertical" />
    </>
  )
}
